export const EN = 'en';
export const KH = 'kh';
export const FEMALE = 2;
export const MALE = 1;
//export const COURSE_ID = "kKXaahAWXVeslSge0Xnk";

export const ACTIVITY_TYPE_VIDEO = 1;
export const ACTIVITY_TYPE_QUIZ = 2;
export const ACTIVITY_TYPE_PAGE = 3;
export const ACTIVITY_TYPE_SURVEY = 4;
export const ACTIVITY_TYPE_FORM_TEAM = 5;
export const ACTIVITY_TYPE_CANVAS = 6;
export const ACTIVITY_TYPE_CHECK_LIST = 7;
// Cloud firestore

let url =
  'https://firebasestorage.googleapis.com/v0/b/smart-elearning-platform.appspot.com/o/';
if (process.env.REACT_APP_DEPLOY === 'staging')
  url =
    'https://firebasestorage.googleapis.com/v0/b/smart-elearning-dev.appspot.com/o/';

export const CLOUD_STORAGE_PREFIX = url;
export const ALT_MEDIA = '?alt=media';

export const QUIZ_IMAGE = `${CLOUD_STORAGE_PREFIX}quizzes%2F`;

// Jw Player
export const PLAYER_SCRIPT = 'https://cdn.jwplayer.com/libraries/V43CbzpK.js';
export const PLAYER_ID = 'V43CbzpK';

export const HOST = window.location.host;
export const HOST_NAME = window.location.hostname;

export const VIMEO_BASE_PATH = 'https://vimeo.com/';

export const EDITOR_WYSIWYG_TOOLBAR = {
  options: [
    'inline',
    //"blockType",
    //"fontSize",
    'list',
    'textAlign',
    'history',
  ],
  // inline: { inDropdown: true },
  // list: { inDropdown: true },
  // textAlign: { inDropdown: true },
  // link: { inDropdown: true },
  // history: { inDropdown: true }
};

export const EDITOR_CREATE_EMPTY = '<p></p>';

export const PRIMARY_COLOR = '#009533';
export const SECONDARY_COLOR = '#0095331c';

export const SATISFY = 1;
export const UN_SATISFY = 2;

// export const SCREEN_XS=768;
export const SCREEN_SM = 768;
export const SCREEN_MD = 992;
export const SCREEN_LG = 1200;

export const SESSION_ID_FORM_TEAM = 'wBXhBxFaHVuOqDXrpPwU';
export const ACTIVITY_ID_FORM_TEAM = '5Q9QEpZfFCTjIDtKjWVa';
